import { Input } from 'components/atoms';
import { useFormikField } from 'hooks/useFormikField';
import { IFieldProps } from 'types/components/inputs/input.interface';

const FieldInputForm = ({ name, isError = true, ...props }: IFieldProps) => {
  const [field, { error, value, status }] = useFormikField<string>(name);

  return (
    <Input.Field
    displayMode={status?.displayMode}
    // isLoading={status?.isLoading}
      {...props}
      {...field}
      value={value}
      onChange={e => {
        field.onChange(e);
        props.onChange && props.onChange(e);
      }}
      error={error}
    />
  );
};

export default FieldInputForm;
